export default function Footer() {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <footer className="bg-gradient-to-br from-gray-900 via-slate-900 to-gray-900 text-white pt-20 pb-8">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          {/* Company Info */}
          <div className="lg:col-span-1">
            <span className="text-2xl font-bold tracking-tight text-white mb-6 block">
              KN-Systems <span className="font-medium">Limited</span>
            </span>
            <p className="text-gray-400 text-sm leading-relaxed mb-6">
              Expert IT infrastructure solutions based on open-source technology. Empowering businesses with scalable, secure, and efficient systems.
            </p>
            <div className="flex items-center space-x-4">
              <a href="#linkedin" className="w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-lg transition-all cursor-pointer">
                <i className="ri-linkedin-fill text-xl"></i>
              </a>
              <a href="#twitter" className="w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-lg transition-all cursor-pointer">
                <i className="ri-twitter-x-fill text-xl"></i>
              </a>
              <a href="#github" className="w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-lg transition-all cursor-pointer">
                <i className="ri-github-fill text-xl"></i>
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-bold mb-6">Services</h4>
            <ul className="space-y-3">
              <li>
                <button onClick={() => scrollToSection('features')} className="text-gray-400 hover:text-white transition-colors text-sm cursor-pointer">
                  Virtualization & Infrastructure
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('features')} className="text-gray-400 hover:text-white transition-colors text-sm cursor-pointer">
                  Backup & Storage Design
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('features')} className="text-gray-400 hover:text-white transition-colors text-sm cursor-pointer">
                  Network Security & Monitoring
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('features')} className="text-gray-400 hover:text-white transition-colors text-sm cursor-pointer">
                  Systems Design & Support
                </button>
              </li>
            </ul>
          </div>

          {/* Technology Partners */}
          <div>
            <h4 className="text-lg font-bold mb-6">Technology Partners</h4>
            <ul className="space-y-3">
              <li className="text-gray-400 text-sm">Proxmox</li>
              <li className="text-gray-400 text-sm">ElasticSearch</li>
              <li className="text-gray-400 text-sm">Palo Alto Networks</li>
              <li className="text-gray-400 text-sm">Fortigate</li>
              <li className="text-gray-400 text-sm">Unifi</li>
              <li className="text-gray-400 text-sm">TrueNAS Storage</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-bold mb-6">Get in Touch</h4>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3">
                <i className="ri-mail-line text-teal-400 text-lg mt-0.5"></i>
                <a href="mailto:info@kn-systems.com" className="text-gray-400 hover:text-white transition-colors text-sm cursor-pointer">
                  info@kn-systems.com
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <i className="ri-phone-line text-teal-400 text-lg mt-0.5"></i>
                <a href="tel:+1234567890" className="text-gray-400 hover:text-white transition-colors text-sm cursor-pointer">
                  +852 5982 2655
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <i className="ri-customer-service-line text-teal-400 text-lg mt-0.5"></i>
                <span className="text-gray-400 text-sm">
                  24/7 Support Available
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/10">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-gray-400 text-sm text-center md:text-left">
              © {new Date().getFullYear()} KN-Systems Limited. All rights reserved.
            </p>
            <div className="flex items-center space-x-6">
              <a href="#privacy" className="text-gray-400 hover:text-white transition-colors text-sm cursor-pointer">
                Privacy Policy
              </a>
              <a href="#terms" className="text-gray-400 hover:text-white transition-colors text-sm cursor-pointer">
                Terms of Service
              </a>
              <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors text-sm cursor-pointer">
                Website Builder
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
